<template>
  <!-- 删除监控-选择商品 -->
  <el-dialog append-to-body title="选择商品" :visible="isShow" width="1090px" :before-close="popupClose">
    <!-- <my-popup
    title="选择商品"
    :zIndex="'3303'"
    width="1090"
    :flag="isShow"
    @close="popupClose"
  > -->
    <div style="margin: 10px 20px 20px 0px">
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="按sku选择" name="second"></el-tab-pane>
        <el-tab-pane label="导入sku" name="3"></el-tab-pane>
      </el-tabs>
    </div>
    <!-- 头部查询表单 -->
    <div class="headSearchForm" v-if="!leadIntoSku">
      <inputForm :inputData="inputData" ref="inputForm" @toParentVal="searchForm" :btnPosition1="true" :immediately="true"></inputForm>
    </div>
    <!-- 选择商品区块 -->
    <div class="goodsContent" v-if="!leadIntoSku">
      <!-- 左边盒子 -->
      <div class="left">
        <div class="titleBox">
          <button class="update" @click="updateGoods">更新</button>
          <span class="tit">店内商品</span>
          <span class="all" @click="selectAll()">全选</span>
        </div>
        <!-- 商品滚动盒子 -->
        <div class="goodsScrollBox">
          <div v-loading="tableLoading">
            <template v-if="goodsList.length == 0">
              <div class="notData">暂无数据</div>
            </template>
            <div class="goods" :class="{ isAdd: item.isAdd }" v-for="item in goodsList" :key="skuSearch ? item.skuId : item.wareId">
                <img :src="item.logo" class="avar" alt="商品图片" />
                <div class="desc">
                  <a :href="item.itemUrl" target="_blank">
                  <p :title="item.wareTitle" class="goodsName">
                    {{ item.wareTitle }}
                  </p>
                </a>
                  <div class="foot">
                    <span v-if="skuSearch" class="goodsId">sku ID:{{ item.skuId }}</span>
                    <span v-else class="goodsId">商品编码:{{ item.wareId }}</span>
                    <span class="money">￥{{ item.jdPrice }}</span>
                  </div>
                </div>
              <img src="../assets/images/add_icon.png" class="addIcon" alt="添加icon" @click="addGoods(item)" />
            </div>
          </div>
        </div>
        <!-- 分页 -->
        <el-pagination
          @size-change="handleLeftSizeChange"
          @current-change="handleLeftCurrentChange"
          :current-page="currentLeftPage"
          background
          small
          :page-sizes="[5, 10, 50, 100]"
          :page-size="pageSizeLeft"
          :pager-count="5"
          layout="total, sizes, prev, pager, next, jumper"
          class="pagination"
          :total="total"
        >
        </el-pagination>
      </div>
      <!-- 右边盒子 -->
      <div class="right" v-loading="selectedGoodsLoading">
        <div class="titleBox">
          <span class="tit"
            >已选商品
            <span style="color: #7B61FF">（{{ selectedGoodsList.length }}）</span>
          </span>
          <span class="clear" @click="empty()">清空</span>
        </div>
        <!-- 商品滚动盒子 -->

        <div class="goodsScrollBox">
          <template v-if="selectedGoodsList.length == 0">
            <div class="notData">暂无数据</div>
          </template>
          <template>
            <div class="goods" v-for="(item, index) in showSelectedGoodsList" :key="skuSearch ? item.skuId : item.wareId">
              <img :src="item.logo" class="avar" alt="商品图片" />
              <div class="desc">
                <p :title="item.wareTitle" class="goodsName">
                  {{ item.wareTitle || item.skuName }}
                </p>
                <div class="foot">
                  <span v-if="skuSearch" class="goodsId">sku ID:{{ item.skuId }}</span>
                  <span v-else class="goodsId">商品编码:{{ item.wareId }}</span>
                  <span class="money">￥{{ item.jdPrice }}</span>
                </div>
              </div>
              <img src="../assets/images/clear_icon.png" class="clearIcon" alt="添加icon" @click="clearGoods(item, index)" />
            </div>
          </template>
        </div>
        <!-- 分页 -->
        <el-pagination
          @size-change="handleRigthSizeChange"
          @current-change="handleRightCurrentChange"
          :current-page="currentRightPage"
          small
          :pager-count="5"
          background
          :page-sizes="[5, 10, 50, 100]"
          :page-size="pageSizeRight"
          layout="total, sizes, prev, pager, next, jumper"
          class="pagination"
          :total="selectedGoodsList.length"
        >
        </el-pagination>
      </div>
    </div>
        <!-- 导入sku -->
        <div v-if="leadIntoSku" style="margin-top: -10px;">
      <div style="margin-bottom: 16px;display: flex;flex-direction: column;height: 48px;">
        <div style="margin-bottom: 16px; height: 16px;display: flex;align-items: center;flex-direction: row;">
        <i slot="reference" class="el-icon-warning"  style="width: 14px;height: 14px;margin-right: 8px;color: #F89F39;" alt=""></i>
        <span style="color: #F89F39;">导入的sku在sku列表选中及查看</span>
        </div>
        <div style="width: 14px;height: 14px;margin-right: 8px;display: flex;align-items: center;flex-direction: row;">
          <el-radio v-model="SkuRadio" label="手动输入">手动输入</el-radio>
          <el-radio v-model="SkuRadio" label="上传文件">上传文件</el-radio>
        </div>
      </div>

      <div v-if="SkuRadio == '手动输入'" style="height: 282px;">
        <el-input style="width: 400px;" type="textarea" :autosize="{ minRows: 8, maxRows: 8}" placeholder="多个sku用英文逗号隔开或者一行一个" v-model="textareaSKU"></el-input>
      </div>
      <div v-if="SkuRadio == '上传文件'" style="margin-bottom: 200px;display: flex;flex-wrap: wrap;">
        <el-upload
          action=""
          ref="upload"
          :on-exceed="refile"
          :on-success="handleSuccess"
          :show-file-list="true"
          :limit="1"
          :file-list="fileList"
          accept=".csv, .txt, .xls, .xlsx"
          :auto-upload="false"
         >
        <button class="confirmUpload" slot="trigger" @click.prevent="">选择文件</button>
        </el-upload>
        <el-button style="margin-left: 8px;" @click.prevent="openExe" type="text">下载导入模板></el-button>
         <!-- <div style="width: 100%;"><i class="el-icon-document"></i>测试文件.xlsx</div> -->
      </div>
      <!-- <div class="footer">
        <div style="width: 100%;">
          <button class="confirm" style="margin: 0 8px;" @click.prevent="IntoSku">确认导入</button><span>成功导入{{successSku}}个，失败{{errorSku}}个</span>
        </div>
      </div> -->
    </div>
    <!-- 底部按钮 -->
    <div class="footer">
      <div style="width: 100%;" v-if="leadIntoSku">
          <button class="confirm" style="margin: 0 8px;" @click.prevent="IntoSku">确认导入</button><span>成功导入<span style="color: #7B61FF;">{{successSku}}</span>个，失败<span style="color: #7B61FF;">{{errorSku}}</span>个</span>
      </div>
      <el-button class="cancel" @click="cancel">取消</el-button>
      <el-button type="primary" @click="sure" v-loading="sureLoading" :disabled="disabled">确定</el-button>
    </div>

    <!-- 选择分组弹窗 -->
    <el-dialog class="creatDialog" width="800px" title="选择分组" :visible.sync="selectVisible" append-to-body>
      <div style="height: 400px;overflow: auto;">
        <el-table v-loading="tableLoding" tooltip-effect="light" :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }" :row-style="{'height':'48px'}" :cell-style="{ 'text-align': 'left','height':'48px !important' }" :data="selectTable" border style="width: 100%">
          <el-table-column prop="groupName" label="分组名称">
          </el-table-column>
          <el-table-column prop="skuNum" label="所选sku数" width="180">
          </el-table-column>
          <el-table-column label="操作" width="120">
            <template slot-scope="scope">
              <div style="width: 100%;height:100%;display: flex;align-items: center;">
                <span @click="addGroup(scope.row.groupId)" style="color:#2768FF;cursor: pointer;" >添加</span>
                <span @click="delGroup(scope.row.groupId)" style="color:#2768FF;margin-left: 12px;cursor: pointer;" >删除</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <!-- 保存分组 -->
    <el-dialog class="creatDialog" width="500px" title="保存分组" :visible.sync="saveVisible" append-to-body>
      <div>
        <el-radio v-model="saveRadio" label="新建分组">新建分组</el-radio>
        <el-radio v-model="saveRadio" label="已有分组">已有分组</el-radio>
        <div style="display: flex;flex-wrap: nowrap;margin-top: 8px;" v-if="saveRadio=='新建分组'">
          <div style="width: 100px;display: flex;align-items: center;"><span style="color: red;">*</span>分组名称：</div>
          <el-input placeholder="请输入分组名称" v-model="groupName" maxlength="20" show-word-limit />
        </div>
        <div style="display: flex;flex-wrap: nowrap;margin-top: 8px;" v-if="saveRadio=='已有分组'">
          <div style="width: 83px;display: flex;align-items: center;"><span style="color: red;">*</span>选择分组：</div>
          <el-select v-model="selsectGroup" placeholder="请选择">
            <el-option v-for="item in groupOptions" :key="item.groupId" :label="item.groupName" :value="item.groupId"></el-option>
          </el-select>
          <!-- <el-input placeholder="请输入分组名称" v-model="groupName" maxlength="20" show-word-limit /> -->
        </div>
      </div>
      <span slot="footer" class="footer">
        <el-button class="cancel" @click.prevent="saveVisible = false" >取消</el-button>
        <el-button type="primary" style="margin-left: 8px;" @click.prevent="saveSpuList()">确定</el-button>
      </span>
    </el-dialog>
  </el-dialog>
  <!-- </my-popup> -->
</template>

<script>
import { getSellercats, getTaobaoItemList, getTaobaoItemListSku, addToGroup, getGroupList, delSkuGroup, getSkuListByGroup, SKUinputText, importSkuFile } from "@/api/analysis/ware-controller";
import myPopup from "./myPopup";
import inputForm from "./inputForm";
import { synchroJdWare } from "@/api/serviceCenter/popCommentWareAnalysis";
import { checkProduct } from "@/api/integralCenter/prizeCenter.js";

export default {
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    selectGoods: {
      type: Array,
      default: () => {
        return [];
      },
    }, // 用于回显选中的商品
    moduleType: {
      type: Boolean,
      default: false,
    },
    skuSearch: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default:false
    },
    // 通过skuIds回显商品的使用参考 src/views/integralCenter/components/gifBagStyle.vue
    // 新增属性：用于通过skuIds字符串回显商品
    skuIdsString: {
      type: String,
      default: "",
    },
    echoByIds: { // 是否通过商品id回显
      type: Boolean,
      default: false,
    },
    // 是否为互动活动
    isInteract: {
      type: Boolean,
      default: false,
    },
    isSupportVirtualGroup: {
      type: Boolean,
      default: false,
    },
    limitNum: {
      type: Number,
      default: 0,
    }
  },
  watch: {
    isShow(newVal) {
      // if (newVal && !this.moduleType) {
      //   console.log(this.selectGoods, 123456);
      //   const ids =
      //     this.selectGoods && this.selectGoods.map((item) => +item.wareId);
      //   // debugger;
      //   this.goodsList.forEach((item) => {
      //     console.log(item);
      //     // 避免直接赋值导致左右两侧商品盒子数组地址不一致，状态没有同步响应
      //     const state = ids.includes(item.wareId);
      //     const isrepeat = this.selectedGoodsList.find(
      //       (data) => data.wareId == item.wareId
      //     );
      //     console.log(this.selectedGoodsList, 155555555);
      //     //  this.selectedGoodsList.push(item);
      //     if (state && !isrepeat) {
      //       this.selectedGoodsList.push(item);
      //       item.isAdd = true;
      //       console.log(this.selectedGoodsList, 1666666);
      //     }
      //   });
      // }
      if (newVal && this.moduleType) {
        console.log(this.selectGoods);
        this.selectedGoodsList = JSON.parse(JSON.stringify(this.selectGoods));
        this.showSelectedGoodsList = JSON.parse(JSON.stringify(this.selectGoods));
        if (this.skuSearch) {
          this.ids = this.selectGoods.map((i) => Number(i.skuId));
        } else {
          this.ids = this.selectGoods.map((i) => Number(i.wareId));
        }
        this.$nextTick(() => {
          this.$refs.inputForm.formSearch();
          this.GroupList();
        });
        // console.log(this.selectGoods, this.ids);
      }
    },
    // 监听skuIdsString变化，当有值时自动获取商品信息并回显
    skuIdsString: {
      handler(newVal) {
        if (newVal && this.isShow && this.echoByIds) {
          this.getGoodsBySkuIds(newVal);
        }
      },
      immediate: true
    }
  },
  components: {
    myPopup,
    inputForm,
  },
  data() {
    return {
      sureLoading: false,
      leadIntoSku:false,
      activeName:'second',
      // 1.11 分组弹窗参数
      saveRadio:'新建分组',
      groupName:'',
      groupOptions:[],
      selsectGroup:'',
      selectVisible:false,
      saveVisible:false,
      selectTable:[], //选择分
      tableLoding:false,

      // 1.11 导入sku
      filesuccess: false,
      leadIntoSku: false, //导入sku
      textareaSKU: '', //手动输入sku值
      successSku: 0,
      errorSku: 0,
      SkuRadio: '手动输入',
      fileList: [],


      inputData: [
        // 头部查询表单配置项
        {
          name: "商品类目:",
          placeholder: "请选择",
          val: "categoryId",
          cascaderArr: [],
          multiple: this.skuSearch,
          width: 240,
        },
        {
          name: "SKU ID:",
          val: "skuIdStr",
          placeholder: "请输入SKU ID",
          width: 240,
          // isNumberN: true,
        },
        {
          name: "商品状态:",
          val: "wareStatus",
          default: '',
          selectArr: [
            { label: "全部", id: '' },
            { label: "上架", id: 1 },
            { label: "下架", id: 2 },
          ],
          width: 136,
        },
        {
          name: "商品编码:",
          val: "wareIdStr",
          placeholder: "请输入商品编码，多个请用,隔开",
          width: 240,
          isNumberN: true,
        },
      ],
      total: 0,
      goodsList: [], // 左边店内商品数据

      currentLeftPage: 1, // 左边店内商品当前页

      selectedGoodsList: [], // 右边已选商品数据
      showSelectedGoodsList: [], // 右边显示已选商品

      currentRightPage: 1, // 右边已经商品当前页

      tableLoading: false, //左盒子loading
      ids: [], //已选商品id集合,防止同一个商品可被多次选中

      pageSizeLeft: 5,
      pageSizeRight: 5,
      fromObj: {
        wareId: "",
        skuStatus: 1,
        skuIdStr: "",
        categoryId: "",
      },
      selectedGoodsLoading: false,
    };
  },
  created() {
    if (this.moduleType) {
      this.selectedGoodsList = JSON.parse(JSON.stringify(this.selectGoods));
      // 将已选商品ID集合成ids数组
      this.ids = this.selectGoods.map((i) => {
        if (i.skuId) {
          return Number(i.skuId);
        } else {
          return Number(i.wareId);
        }
      });
    }
    // sku维度商品查询
    if (this.skuSearch) {
      // this.inputData.splice(3,1);
      this.inputData.splice(2, 1);

      this.inputData.splice(2, 0, {
        name: "商品状态",
        val: "skuStatus",
        default: '',
        selectArr: [
          { label: "全部", id: ''},
          { label: "上架", id: 1 },
          { label: "下架", id: 2 },
        ],
        width: 136,
      });
      this.inputData.push({
        name: "商品名称:",
        val: "skuName",
        placeholder: "请输入商品名称",
        width: 240,
      });
    } else {
      this.inputData.push({
        name: "商品名称:",
        val: "wareTitle",
        placeholder: "请输入商品名称",
        width: 240,
      });
    }
    if(this.echoByIds && this.skuIdsString){
      this.getGoodsBySkuIds(this.skuIdsString);
    }
  },
  mounted() {
    this.init(); //初始化
    console.log("回显选中商品==", this.selectedGoodsList, this.selectGoods);

    // 根据分页size截取数组
    this.sliceArr(this.currentRightPage, this.pageSizeRight);
  },
  methods: {
    refile(file){
      console.log(file[0])
      this.$refs.upload.clearFiles()
      this.$refs.upload.handleStart(file[0]);
    },
    handleClick(tab) {
      if (tab.name == "second") {
        this.leadIntoSku = false;
        setTimeout(()=>{
          this.$refs.inputForm.formSearch();
        },100)
      }
      if (tab.name == "3") {
        this.leadIntoSku = true;
      }
    },
    // 添加商品
    async addGroup(id) {
      let res = await getSkuListByGroup(id)
      if(res.code==1){
        res.data.forEach(item=>{
          let ispush = true
          this.selectedGoodsList.forEach(it=>{
            if(it.skuId == item.skuId){
              ispush = false
            }
          })
          if(ispush){
            if(!item.title){
              item.title = item.skuName
            }
            this.addGoods(item)
          }
        })
        this.$refs.inputForm.formSearch();
        this.selectVisible = false
      }else{
        this.$message({
          type: 'error',
          message: res.message
        });
      }
    },
    // 删除商品组
    delGroup(id) {
      this.$confirm('是否确认删除此分组?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delSkuGroup(id).then(res => {
          if (res.code == 1) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.GroupList()
          } else {
            this.$message({
              type: 'error',
              message: res.message
            });
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    // 获取商品列表
    async GroupList(){
      this.tableLoding = true
      let res = await getGroupList()
      if(res.code==1){
        this.groupOptions = res.data
        this.selectTable = res.data
        this.tableLoding = false
      }else{
        this.tableLoding = false
      }
    },

    // 保存sku分组  
    saveSpuList(){
      let formData={
        groupId:'',
        groupName:'',
        // idList:this.selectedGoodsList,
      }
      if(this.saveRadio=='新建分组'){
        if(this.groupName == ''){
          this.$message.warning('分组名称不可为空')
          return
        }
        formData.groupName = this.groupName
      }
      if(this.saveRadio=='已有分组'){
        if(this.selsectGroup == ''){
          this.$message.warning('请选择分组')
          return
        }
        formData.groupId = this.selsectGroup
        this.groupOptions.forEach( item => {
          if(item.groupId == formData.groupId){
            formData.groupName = item.groupName
          }
        })
      }
      formData.idList = this.selectedGoodsList.map(item=>{
        return item.skuId
      })
      addToGroup(formData).then(res=>{
        if(res.code==1){
          this.saveVisible = false
          this.$message.success('创建成功')
          this.GroupList()
        }else{
          this.$message.error(res.message)
        }
      })
    },
    // 选择分组
    selectGoodsList(){
      this.selectVisible = true
    },
    // 保存分组
    saveGoodsList(){
      this.saveVisible = true
      this.groupName = ''
      this.selsectGroup = ''
    },
    // 下载模板文件
    openExe(){
      window.open('https://yeion-public.s3.cn-north-1.jdcloud-oss.com/template/SKU%E5%AF%BC%E5%85%A5%E6%A8%A1%E7%89%88.xlsx', '_blank');
    },
    // 导入文件
    handleSuccess(){
      this.filesuccess = true
    },
    beforeUpload(file) {
      console.log("---file---")
      console.log(file)
      const fileSize = file.size / 1024 / 1024 < 50;
      if (!fileSize) {
        this.message.warning("上传模板大小不能超过 50MB!");
        return  false;
      }
      let formData = new FormData();
      formData.append('file', file.raw);
      console.log(file.raw)
      console.log('formData:', formData);
      importSkuFile(formData).then(res => {
        if(res.code==1){
            this.$message.success('导入成功！')
            this.$refs.upload.clearFiles()
            this.successSku = res.data.successNum
            this.errorSku = res.data.failNum
            res.data.skuList.forEach( item => {
              let ispush = true
              this.selectedGoodsList.forEach(it=>{
                if(it.skuId == item.skuId){
                  ispush = false
                }
              })
              if(ispush){
                if(!item.title){
                  item.title = item.skuName
                }
                this.addGoods(item)
              }
            })
          }else{
            this.$message.error(res.message);
          }
      })
      return false;
    },
    // 导出sku
    IntoSku(){
      if(this.SkuRadio == '手动输入'){
        let lines = this.textareaSKU.split('\n');  
        let finalArray = lines.flatMap(line => line.split(','));  
        finalArray = finalArray.map(item => item.trim());
        let skuId = finalArray.join(',')
        SKUinputText({
          skuId:skuId
        }).then( res=>{
          if(res.code==1){
            this.$message.success('导入成功！')
            this.successSku = res.data.successNum
            this.errorSku = res.data.failNum
            res.data.skuList.forEach( item => {
              let ispush = true
              this.selectedGoodsList.forEach(it=>{
                if(it.skuId == item.skuId){
                  ispush = false
                }
              })
              if(ispush){
                if(!item.title){
                  item.title = item.skuName
                }
                this.addGoods(item)
              }
            })
          }else{
            this.$message.error(res.message);
          }
        })
      }
      if(this.SkuRadio == '上传文件'){
        this.beforeUpload(this.$refs.upload.uploadFiles[0])
      }
    },

    init() {
      // 获取商品类目
      getSellercats().then((res) => {
        let data = this.transverter(res.data);
        // console.log(data);
        this.getTrees(data);
        // console.log(data);
        // debugger
        let list = data.filter((item) => item.parent_id == 0);
        // console.log('list',list);
        let cascaderArr = list.map((item) => {
          return {
            label: item.label,
            value: item.value,
            children: item.children,
          };
        });
        console.dir(cascaderArr);

        this.inputData[0].cascaderArr = cascaderArr;
        // console.log(this.inputData[0]);
      });
      this.$nextTick(() => {
        // this.$refs.inputForm.formSearch();
        this.handleSearch();
      });
    },
    sure() {
      if (this.limitNum && this.selectedGoodsList.length > this.limitNum) {
        return this.$message.warning(`选择商品不能超过${this.limitNum}个`);
      }
      const isActivity = this.$parent && this.$parent.activityData && this.$parent.activityData.id;
      console.log('isActivity',isActivity);
      if (this.isInteract || (isActivity != undefined || isActivity != null)) {
        const skuIds = this.selectedGoodsList.map((v) => v.skuId);
        if (skuIds.length == 0) {
          this.$emit("close", this.selectedGoodsList);
          return;
        }
        if(!this.isSupportVirtualGroup) {
        this.sureLoading = true;
        checkProduct(skuIds)
          .then((res) => {
            this.sureLoading = false;
            if (res.code == 1) {
              if (res.data.isHave) {
                this.$message.warning("活动暂不支持选择虚拟套装和影分身商品");
              } else {
                this.$emit("close", this.selectedGoodsList);
              }
            } else {
              this.$message.warning(res.message);
            }
          })
          .catch((err) => {
            console.log(err);
            this.sureLoading = false;
          });
        } else {
          this.$emit("close", this.selectedGoodsList);
        }
        return;
      }
      this.$emit("close", this.selectedGoodsList);
    },
    cancel() {
      this.$emit("close", false);
    },
    transverter(data) {
      // 排重
      let obj = {};
      for (let i = 0; i < data.length; i++) {
        obj[data[i]["categoryId"]] = data[i];
      }
      let arr = Object.values(obj);
      var newData = [];
      // console.log(arr);
      for (var i = 0; i < arr.length; i++) {
        newData[i] = {
          value: arr[i].categoryId,
          parent_id: arr[i].parentId,
          label: arr[i].name,
          isChecked: false,
        };
      }
      return newData;
    },
    getTrees(list, parent_id = 0) {
      let parentObj = {};
      list.forEach((o) => {
        parentObj[o.id] = o;
      });
      if (!parent_id) {
        return list
          .filter((o) => !parentObj[o.parent_id])
          .map((o) => {
            if (this.getTrees(list, o.value).length == 0) {
              // console.log(this.getTrees(list, o.value).length);
              delete o.children;
              return o;
            } else {
              return (o.children = this.getTrees(list, o.value)), o;
            }
          });
      } else {
        return list
          .filter((o) => o.parent_id == parent_id)
          .map((o) => {
            if (this.getTrees(list, o.value).length == 0) {
              // console.log(this.getTrees(list, o.value).length);
              delete o.children;
              return o;
            } else {
              return (o.children = this.getTrees(list, o.value)), o;
            }
          });
      }
    },
    /**
     * 弹窗隐藏
     */
    popupClose() {
      this.$emit("close", false);
    },
    /**
     * 表单查询商品列表
     */
    searchForm(form) {
      this.tableLoading = true;
      form.current = this.currentLeftPage;
      console.log("form.categoryId:", form);
      form.categoryId = form.categoryId.length && Array.isArray(form.categoryId) ? form.categoryId.join(",") : form.categoryId;
      console.log(this.pageSizeLeft);
      if (this.skuSearch) {
        getTaobaoItemListSku({
          ...form,
          size: this.pageSizeLeft,
        }).then((res) => {
          this.tableLoading = false;
          if (res.code == 1) {
            // console.log(res.data.records);
            res.data.records.map((item) => {
              item.wareTitle = item.skuName;
            });
            this.goodsList = res.data.records;
            console.log("this.goodsList", this.goodsList);
            console.log(this.ids);
            if (this.moduleType) {
              this.goodsList.forEach((item) => {
                // 避免直接赋值导致左右两侧商品盒子数组地址不一致，状态没有同步响应
                const state = this.ids.includes(Number(item.skuId));
                if (state) {
                  item.isAdd = true;
                }
              });
            }
            console.log(res.data.records);
            this.total = +res.data.total;
          } else {
            this.goodsList = [];
          }
        });
      } else {
        // console.log(this.pageSizeLeft);
        getTaobaoItemList({
          ...form,
          page: form.current,
          pageSize: this.pageSizeLeft,
        }).then((res) => {
          console.log(res.data);
          this.tableLoading = false;
          if (res.data == null) {
            this.goodsList = [];
          }
          if (res.code == 1) {
            this.goodsList = res.data.records;
            if (this.moduleType) {
              console.log(this.ids);
              this.goodsList.forEach((item) => {
                // console.log(item.wareId);
                // 避免直接赋值导致左右两侧商品盒子数组地址不一致，状态没有同步响应
                const state = this.ids.includes(item.wareId);
                // console.log(state);
                if (state) {
                  item.isAdd = true;
                }
                var itemUrlX = "";
                // 根据查询的skuId 设置跳转地址
                if (form.skuId) {
                  var skuList = item.skuList;
                  if (skuList) {
                    skuList.forEach((skuItem) => {
                      if (skuItem.skuId == form.skuId) {
                        itemUrlX = skuItem.itemUrl;
                      }
                    });
                  }
                }
                if (itemUrlX) {
                  item.itemUrl = itemUrlX;
                }
              });
              this.$forceUpdate();
              console.log("this.goodsList:", this.goodsList);
            }
            // function myIsNaN(value) {
            //     return typeof value === 'number' && !isNaN(value);
            // }
            this.sliceArr(this.currentRightPage, this.pageSizeRight);
            console.log(res.data.records);
            this.total = +res.data.total;
          } else {
            this.goodsList = [];
          }
        });
      }
    },
    // 搜索
    handleSearch(form = this.fromObj) {
      console.log(this.fromObj, 5555);
      this.tableLoading = true;
      form.current = this.currentLeftPage;
      if (form.categoryId) {
        form.categoryId = form.categoryId;
      }
      if (this.skuSearch) {
        getTaobaoItemListSku({
          ...form,
          size: this.pageSizeLeft,
        }).then((res) => {
          this.tableLoading = false;
          if (res.code == 1) {
            res.data.records.map((item) => {
              item.wareTitle = item.skuName;
            });
            this.goodsList = res.data.records;
            if (this.moduleType) {
              this.goodsList.forEach((item) => {
                // 避免直接赋值导致左右两侧商品盒子数组地址不一致，状态没有同步响应
                // const state = this.ids.includes(item.skuId);
                // const state = this.ids.indexOf(item.skuId);
                this.ids.forEach((ele) => {
                  if (ele == Number(item.skuId)) {
                    item.isAdd = true;
                  }
                });
              });
            }
            // console.log(res.data.records);
            this.total = +res.data.total;
          } else {
            this.goodsList = [];
          }
        });
      } else {
        getTaobaoItemList({
          ...form,
          page: form.current,
          pageSize: this.pageSizeLeft,
        }).then((res) => {
          this.tableLoading = false;
          if (res.data == null) {
            this.goodsList = [];
          }
          if (res.code == 1) {
            this.goodsList = res.data.records;
            if (this.moduleType) {
              // console.log(this.ids);
              this.goodsList.forEach((item) => {
                // 避免直接赋值导致左右两侧商品盒子数组地址不一致，状态没有同步响应
                const state = this.ids.includes(item.wareId);
                // console.log(state);
                if (state) {
                  item.isAdd = true;
                }
              });
            }
            // function myIsNaN(value) {
            //     return typeof value === 'number' && !isNaN(value);
            // }
            this.sliceArr(this.currentRightPage, this.pageSizeRight);
            // console.log(res.data.records);
            this.total = +res.data.total;
          } else {
            this.goodsList = [];
          }
        });
      }
    },
    /**
     * 更新商品
     */
    updateGoods() {
      // this.$refs.inputForm.formSearch();
      synchroJdWare().then((res) => {
        console.log(res);
        if (res.code == "1") {
          this.$message.success("正在同步店铺商品");
        } else {
          this.$message.warning(res.message);
        }
      });
    },
    /**
     * 添加商品
     */
    addGoods(item) {
      // console.log(222222222222222222222);
      if (item.isAdd) return;
      item.isAdd = true;
      if (this.skuSearch) {
        this.ids.push(Number(item.skuId));
      } else {
        this.ids.push(item.wareId);
      }
      this.selectedGoodsList.push(item);
      this.sliceArr(this.currentRightPage, this.pageSizeRight);
    },
    /**
     * 全选
     */
    selectAll() {
      this.goodsList.forEach((item) => {
        if (this.limitNum&&this.selectedGoodsList.length >= this.limitNum) {
          this.$message.warning(`最多只能选择${this.limitNum}个商品！`)
          return;
        }
        if (!item.isAdd) {
          item.isAdd = true;
          this.selectedGoodsList.push(item);
          // sku维度
          if (this.skuSearch) {
            this.ids.push(Number(item.skuId));
          } else {
            this.ids.push(item.wareId);
          }
        }
      });
      this.sliceArr(this.currentRightPage, this.pageSizeRight);
    },
    /**
     * 左边商品盒子分页事件
     */
    handleLeftSizeChange(val) {
      this.pageSizeLeft = val;
      this.currentLeftPage = 1;
      this.$refs.inputForm.formSearch();
    },
    handleLeftCurrentChange(val) {
      this.currentLeftPage = val;
      this.$refs.inputForm.formSearch();
    },
    /**
     * 删除商品
     */
    clearGoods(item, index) {
      console.log(item.wareId);
      if (this.skuSearch) {
        this.goodsList.forEach((i) => {
          if (i.skuId == Number(item.skuId)) {
            i.isAdd = false;
          }
        });
      } else {
        this.goodsList.forEach((i) => {
          if (i.wareId == item.wareId) {
            i.isAdd = false;
          }
        });
      }
      if (this.moduleType) {
        if (this.skuSearch) {
          this.ids.splice(
            this.ids.findIndex((i) => i === Number(item.skuId)),
            1
          );
        } else {
          this.ids.splice(
            this.ids.findIndex((i) => i === item.wareId),
            1
          );
        }
      }
      this.selectedGoodsList.splice(index, 1);
      this.sliceArr(this.currentRightPage, this.pageSizeRight);
    },
    /**
     * 清空
     */
    empty() {
      console.log(this.ids);
      // return
      if (this.skuSearch) {
        this.goodsList.forEach((item, index) => {
          if (this.ids.includes(Number(item.skuId))) {
            item.isAdd = false;
          }
        });
      } else {
        this.goodsList.forEach((item, index) => {
          if (this.ids.includes(item.wareId)) {
            item.isAdd = false;
          }
        });
      }
      // this.selectedGoodsList.length = 0;
      console.log(this.goodsList);
      this.ids = [];
      this.selectedGoodsList = [];
      this.showSelectedGoodsList = [];
      this.currentRightPage = 1;
    },
    /**
     * 右边商品盒子分页事件
     */
    handleRigthSizeChange(val) {
      this.pageSizeRight = val;
      // 分页size大于右商品盒子数组长度时
      if (this.currentRightPage * this.pageSizeRight > this.selectedGoodsList.length) {
        this.sliceArr(1, this.selectedGoodsList.length);
      } else {
        this.sliceArr(1, val);
      }
    },
    // 右边商品盒子页码事件
    handleRightCurrentChange(val) {
      this.currentRightPage = val;
      this.sliceArr(val, this.pageSizeRight);
    },
    // 根据分页信息截取数组进行显示
    sliceArr(current, size) {
      this.showSelectedGoodsList = this.selectedGoodsList.slice(size * (current - 1), size * current);
      console.log(this.showSelectedGoodsList);
    },
   // 通过skuIds字符串获取商品信息
   getGoodsBySkuIds(skuIdsStr) {
      if (!skuIdsStr) return;
      
      // 显示加载状态
      this.tableLoading = true;
      this.selectedGoodsLoading = true;
      
      // 构建查询参数
      const skuIds = skuIdsStr.split(',').map(id => id.trim()).filter(id => id);
      if (skuIds.length === 0) {
        this.tableLoading = false;
        this.selectedGoodsLoading = false;
        return;
      }
      
      // 存储所有商品数据
      let allGoodsList = [];
      let completedQueries = 0;
      
      // 逐个查询每个SKU
      skuIds.forEach(skuId => {
        getTaobaoItemListSku({
          skuId: skuId,
          size: 1,
          current: 1,
          venderId: this.venderId || undefined
        }).then(res => {
          completedQueries++;
          
          if (res.code == 1 && res.data && res.data.records && res.data.records.length > 0) {
            // 处理返回的商品数据
            const item = res.data.records[0];
            allGoodsList.push({
              skuId: item.skuId,
              logo: item.logo,
              price: item.jdPrice || item.price,
              title: item.skuName || item.wareTitle,
              wareTitle: item.skuName || item.wareTitle,
              jdPrice: item.jdPrice || item.price,
              isAdd: true // 标记为已添加
            });
          }
          
          // 所有查询完成后更新UI
          if (completedQueries === skuIds.length) {
            this.updateGoodsListUI(allGoodsList);
          }
        }).catch(err => {
          completedQueries++;
          console.error(`获取商品信息失败 (SKU: ${skuId}):`, err);
          
          // 所有查询完成后更新UI
          if (completedQueries === skuIds.length) {
            this.updateGoodsListUI(allGoodsList);
          }
        });
      });
    },
    
    // 更新商品列表UI的辅助方法
    updateGoodsListUI(goodsList) {
      this.tableLoading = false;
      this.selectedGoodsLoading = false;
      
      if (goodsList.length > 0) {
        // 更新已选商品列表
        this.selectedGoodsList = goodsList;
        this.showSelectedGoodsList = [...goodsList];
        
        // 更新已选ID列表
        this.ids = goodsList.map(item => Number(item.skuId));
        
        // 更新左侧商品列表的选中状态
        this.$nextTick(() => {
          this.goodsList.forEach(item => {
            if (this.ids.includes(Number(item.skuId))) {
              item.isAdd = true;
            }
          });
        });
        
        console.log('通过skuIds获取到的商品:', goodsList);
      } else {
        this.$message.warning('未找到任何商品信息');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-table .el-table__header-wrapper{
  border-bottom: 1px solid #EBEEF5;
}
.creatDialog{
  z-index: 4000 !important;
  background: #00000080
}

button {
  margin: 0;
  padding: 0 12px;
  height: 32px;
  line-height: 30px;
  border: none;
  outline: none;
  border-radius: 3px;
  // background-color: #fff;
  text-align: center;
  cursor: pointer;
}
.headSearchForm {
  margin-top: 20px;
}
.notData {
  text-align: center;
  color: #909399;
  margin-top: 20%;
}
.goodsContent {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .left,
  .right {
    width: 500px;
    .titleBox {
      position: relative;
      width: 100%;
      height: 40px;
      line-height: 38px;
      border: 1px solid rgba(243, 243, 243, 1);
      box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.04);
      text-align: center;
      color: #333;
      font-size: 14px;
      .all,
      .clear {
        position: absolute;
        right: 10px;
        color: #7b61ff;
        cursor: pointer;
      }
      .update {
        // margin-left: -200px;
        position: absolute;
        left: 10px;
        top: 4px;
        width: 70px;
        font-size: 14px;
        height: 28px;
        color: #ffffff;
        background-color: #7b61ff;
        &:hover {
          color: #fff;
          opacity: 0.9;
          background-color: #7b61ff;
        }
      }
    }
    .goodsScrollBox {
      height: 334px;
      overflow: auto;
      &::-webkit-scrollbar {
        width: 8px;
        height: 10px;
      }
      &::-webkit-scrollbar-track {
        background: rgba(246, 246, 246, 1);
        border-radius: 2px;
      }
      &::-webkit-scrollbar-thumb {
        background: #ddd;
        border-radius: 10px;
      }
      &::-webkit-scrollbar-thumb:hover {
        background: #ddd;
      }
      .goods {
        display: flex;
        align-items: center;
        box-sizing: border-box;
        justify-content: space-between;
        padding: 0 16px;
        height: 80px;
        border-left: 1px solid #f3f3f3;
        border-right: 1px solid #f3f3f3;
        border-bottom: 1px solid #f3f3f3;
        transition: all 0.2s;
        a {
          display: flex;
          align-items: center;
          box-sizing: border-box;
          padding: 0 16px;
          height: 80px;
          flex: 1;
        }
        .avar {
          flex-shrink: 0;
          width: 60px;
          height: 60px;
          background-color: #f9f9f9;
        }
        .desc {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          margin: 0 26px 0 10px;
          .goodsName {
            color: #333;
            font-size: 14px;
            margin: 0;
            display: -webkit-box;
            word-break: break-all;
            text-overflow: ellipsis;
            overflow: hidden;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            // -webkit-line-clamp: 2;
            line-height: 24px;
            // display: -webkit-box;
            // -webkit-box-orient: vertica;
            // overflow: hidden;
            // text-overflow: ellipsis;
          }
          .foot {
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 14px;
            .goodsId {
              color: #999;
            }
            .money {
              color: #ff872f;
            }
          }
        }
        .addIcon {
          flex-shrink: 0;
          width: 24px;
          height: 24px;
          cursor: pointer;
          transition: all 0.2s;
        }
        .clearIcon {
          flex-shrink: 0;
          width: 24px;
          height: 24px;
          cursor: pointer;
        }
      }
      .isAdd {
        background-color: #f9f9f9 !important;
        .addIcon {
          opacity: 0.3;
          cursor: not-allowed;
        }
      }
    }
    .pagination {
      margin-top: 20px;
      text-align: right;
    }
  }
  .left {
  }
  .right {
  }
}
.confirmUpload{
    width: 98px;
    font-size: 14px;
    height: 32px;
    color: #ffffff;
    background-color: #7b61ff;
    &:hover {
      color: #fff;
      opacity: 0.9;
      background-color: #7b61ff;
    }
}
.footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 20px;
  .cancel,
  .confirm {
    width: 98px;
    font-size: 14px;
    height: 32px;
  }
  .cancel {
    margin-right: 8px;
    color: #999999;
    border: 1px solid #cccccc;
    background: rgba(123, 97, 255, 0.1);
    &:hover {
      color: #7b61ff;
      border: 1px solid #7b61ff;
      background-color: #fff4f4;
    }
  }
  .confirm {
    color: #ffffff;
    background-color: #7b61ff;
    &:hover {
      color: #fff;
      opacity: 0.9;
      background-color: #7b61ff;
    }
  }
}
</style>
<style lang="scss">
.el-select-dropdown {
  z-index: 3334 !important;
}
</style>
